export const EventStatus = Object.freeze({
	ACTIVE: 1,
	CANCELED: -1
});



// WEBPACK FOOTER //
// ./src/enums/eventStatus.js